<div id="paydone" style="position: relative;height: 100%;width: 100%;">


  <div id="hello" class="animate__animated animate__heartBeat">

    <p *ngIf="usernameARR.displayName">Hello, {{usernameARR.displayName}}</p>

  </div>


  <div id="serial"
    style="position: relative;text-align: center;padding: 5px;width: 50%px;margin-right: auto;margin-left: auto;margin-top: 40px;">

    <div>
      <h4 style="position: relative;font-size: 25px;">Get Serial:</h4>
      <p style="font-size: 15px;">The serial will save in Buy page.<br><b>Dont leave before Generate!</b></p>
      <mat-form-field class="example-full-width">

        <mat-label>Enter your ID here</mat-label>

        <input matInput type="number" #idNumber>
      </mat-form-field>

      <button color="primary" style="margin-left: 10px;" mat-stroked-button (click)="checkNUm(idNumber.value)">Generate
      </button>
      <div id="result" style="position: relative;">
        <p id="p" *ngIf="idText" style="color: red;"> Please enter your ID</p>
        <p id="p" *ngIf="numLength" style="color: red;">The ID Invalid</p>
      </div>
    </div>



  </div>


</div>

<div style="background-color:#434449b3 ;color: white;display: block;margin-top: 61px;min-height:200px;">
  <p>How to get Serial?
    Write the ID number that appears there in the “ENTER YOUR ID” box, Then press “GENERATE” and your serial will be
    generated and shown.<br> Add the serial into our vsti and press “SAVE”. Saving should be done in the vsti’s root
    folder which is located at “C:\Users\username\Documents\<br>Fananteam\instrument Normally, pressing ”save” will
    direct you to the relevant directory automatically.</p>

</div>
